import React, { useEffect, useRef } from 'react'
import { PrimaryButton } from '@mmsg/louie'
import { Spinner, Alert } from 'react-bootstrap'
import Form from 'react-bootstrap/Form'
import { connect, useSelector } from 'react-redux'
import { fetchUserByOpportunityId } from '../../../actions/userActions'
import { receiveOpportunityId } from '../../../actions/opportunityActions'
import { detectBrowser } from 'actions/browserActions'
import { sendAccessCode } from '../../../actions/authenticationActions'
import { ValidateCaptcha } from 'actions/captchaActions'
import withLocation from '../../withLocation'
import { SBText } from 'components/styledComponents/text'
import ReCAPTCHA from 'react-google-recaptcha'
import AppInMaintenance from './appInMaintenance'
import NotificationContent from 'components/browserNotification/notificationContent'
import { MdErrorOutline } from 'react-icons/md'

const LoginOptionForm = ({
  setCanEnterCode,
  option,
  handleOptionChange,
  search,
  dispatch,
  isFetchingUser,
  email,
  mobile,
  opportunityId,
  isRequestingAccessCode,
  applicationMaintenanceStatus,
  errorMessage,
  changedOption,
  updateChangedOption,
}) => {
  const setBrowser = () => {
    dispatch(detectBrowser())
  }
  useEffect(() => {
    setBrowser()
    if (search.oppId) {
      dispatch(receiveOpportunityId(search.oppId))
      dispatch(fetchUserByOpportunityId(search.oppId))
      document.cookie = 'oppId=' + search.oppId
    }
  }, [])

  const recaptchaRef = useRef()

  const sendVerificationCodeErrorMessage = useSelector(
    (state) => state.accessCode.errorMessage
  )
  const { outdatedBrowser } = useSelector((state) => ({ ...state.browser }))
  const sendCodeHandler = async (event) => {
    recaptchaRef.current.reset()
    const token = await recaptchaRef.current.executeAsync()
    dispatch(sendAccessCode(opportunityId, option, token)).then(() => {
      setCanEnterCode(true)
    }, (error) => {
      updateChangedOption(false)})
  }

  const OnValidatingForCaptcha = async () => {
    const token = await recaptchaRef.current.executeAsync()
    recaptchaRef.current.reset()
    dispatch(ValidateCaptcha(token, dispatch))
  }

  const handleKeyDown = (e, val) => {
    if (e.key === 'Enter') {
      let medium = {
        target: {
          value: val,
        },
      }
      handleOptionChange(medium)
    }
  }

  const captcha = useSelector((state) => state.captcha)

  const spinner = <Spinner animation="border" size="sm" />
  const isError = !!errorMessage || (!search.oppId && !opportunityId)
  return isError ? (
    <Alert variant="danger">
      {errorMessage}
      {!search.oppId && !opportunityId && <>opportunityId is not provided</>}
    </Alert>
  ) : (
    <>
      {/*To load the landing page when there is a application maintenance page to be loaded*/}
      {applicationMaintenanceStatus &&
        applicationMaintenanceStatus.isApplicationOnMaintenance && (
          <>
            <AppInMaintenance
              maintenanceTitle={applicationMaintenanceStatus.maintenanceTitle}
              maintenanceMessage={
                applicationMaintenanceStatus.maintenanceMessage
              }
            />
          </>
        )}

      {/*To load the login page when there is no application maintenance component to be loaded*/}
      {applicationMaintenanceStatus &&
        !applicationMaintenanceStatus.isApplicationOnMaintenance && (
          <Form className="text-center">
            <ReCAPTCHA
              ref={recaptchaRef}
              size="invisible"
              sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
            />
            {outdatedBrowser ? (
              <Alert variant="danger" className="text-left mt-0 w-100">
                <NotificationContent />
              </Alert>
            ) : null}
            <SBText size={2}>Choose your security method</SBText>
            <p className="mt-4 fw">
              <div>
                Before we step you through your estimated tax savings (not to
                mention your shiny new car options), we need to verify your
                identity.
              </div>
            </p>
            <p>
              <div>
                Choose where you want to receive your one-time verification code
                below. Then you’ll be on the road to browsing convenient and
                potential tax-effective benefits in no time.
              </div>
            </p>
            <Form.Check
              custom
              type={`radio`}
              id={`sendCodeByMobile`}
              className={`shadow-sm text-left login-option${
                option === 'mobile' ? ' login-option--selected' : ''
              }`}
            >
              <Form.Check.Input
                type={`radio`}
                name="sendCodeOption"
                value="mobile"
                checked={option === 'mobile'}
                onChange={handleOptionChange}
                disabled={isFetchingUser}
              />
              <Form.Check.Label
                className="text-dark-black"
                tabIndex="0"
                onKeyDown={(e) => handleKeyDown(e, 'mobile')}
              >
                <span>Receive by SMS (recommended)</span>
                <span className="mt-3">
                  Send code to {isFetchingUser ? spinner : mobile}
                </span>
              </Form.Check.Label>
            </Form.Check>

            <Form.Check
              custom
              type={`radio`}
              id={`sendCodeByEmail`}
              className={`shadow-sm text-left login-option${
                option === 'email' ? ' login-option--selected' : ''
              }`}
            >
              <Form.Check.Input
                type={`radio`}
                name="sendCodeOption"
                value="email"
                checked={option === 'email'}
                onChange={handleOptionChange}
                disabled={isFetchingUser}
              />
              <Form.Check.Label
                className="text-dark-black"
                tabIndex="0"
                onKeyDown={(e) => handleKeyDown(e, 'email')}
                value="email"
              >
                <span>Receive by email</span>
                <span className="mt-3">
                  Send code to {isFetchingUser ? spinner : email}
                </span>
              </Form.Check.Label>
            </Form.Check>

            {isRequestingAccessCode && (
              <PrimaryButton extendInMob disabled={isFetchingUser}>
                <>
                  <Spinner
                    as="span"
                    animation="grow"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    className="mr-1"
                  />
                  Sending...
                </>
              </PrimaryButton>
            )}
            {!isRequestingAccessCode && (
              <>
                <PrimaryButton
                  className="clickable"
                  onClick={sendCodeHandler}
                  disabled={isFetchingUser}
                  extendInMob
                >
                  Send verification code
                </PrimaryButton>
              </>
            )}
            {sendVerificationCodeErrorMessage &&
              sendVerificationCodeErrorMessage !== '' &&
              !changedOption && (
                <div className="mt-3">
                   <Alert variant={'danger'} className="d-flex text-left mb-4 w-100">
                    <MdErrorOutline
                      color="#721c24"
                      size={`1.2em`}
                      style={{ minWidth: '20px' }}
                    />
                  
                    {sendVerificationCodeErrorMessage}
                    </Alert>
                  </div>
              )}
          </Form>
        )}
    </>
  )
}

function mapStateToProps(state) {
  const {
    isFetching: isFetchingUser,
    email,
    mobile,
    applicationMaintenanceStatus,
    errorMessage,
  } = state.user
  const { opportunityId } = state.opportunity
  const { isFetching: isRequestingAccessCode } = state.accessCode

  return {
    isFetchingUser,
    email: email,
    mobile: mobile,
    opportunityId,
    isRequestingAccessCode,
    applicationMaintenanceStatus,
    errorMessage,
  }
}

export default connect(mapStateToProps)(withLocation(LoginOptionForm))
